import React, { Fragment } from 'react'
import { Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid';

function ModalHistorialCambiosComponent(props) {

    let dataHistorial = props?.dataHistorial

    let apartado = props?.apartado
    const [openModalHistorial, setOpenModalHistorial] = React.useState(true);
    const handleCloseModal = () => {
        setOpenModalHistorial(false)
        props.setOpenModalHistorial(false)
    }

    const columnsHistorial = [
        { field: 'usuario', headerName: 'Usuario', headerAlign: 'center', flex: 1 },
        { field: 'fecha', headerName: 'Fecha de cambio', headerAlign: 'center', flex: 1 }

    ]

    const rowsHistorial = []
    for (const i in dataHistorial) {
        let fecha = dataHistorial?.[i]?.fechacambio?.substring(0, 10)
        rowsHistorial.push({ id: uuidv4(), fecha: fecha, usuario: dataHistorial?.[i]?.usuariocambio })
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '60%',
        height: 'fit-content',
        bgcolor: 'background.paper',
        border: 'px solid #000',
        boxShadow: 3,
        p: 3,
        opacity: 1,
        borderRadius: '5px'
    };

    const theme = createTheme({
        palette: {
            primary: {
                main: "#EDB75A"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });

    return (
        <Fragment>
            <Modal open={openModalHistorial} onClose={handleCloseModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h5" sx={{ mt: 0, fontFamily: 'Montserrat', textAlign: 'center', fontWeight: 'bold' }}>
                        Historial
                    </Typography>
                    <Typography id="modal-modal-title" variant="h6" sx={{ mt: 0, fontFamily: 'Montserrat', textAlign: 'center' }}>
                        {apartado}
                    </Typography>
                    <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} style={{ color: "black", textAlign: 'justify', fontFamily: 'Montserrat' }}>
                        <div className='container'>
                            <Box sx={{ height: 300, width: '100%', mt: 2 }}>
                                <DataGrid
                                    rows={rowsHistorial}
                                    columns={columnsHistorial}
                                    disableColumnMenu={true}
                                    pageSize={10}
                                    getRowHeight={() => 'auto'}
                                    sx={{
                                        boxShadow: 0,
                                        color: 'black',
                                        border: 0,
                                        backgroundColor: 'white',
                                        fontFamily: 'Montserrat',
                                        '& .MuiDataGrid-cell': {
                                            display: 'block',
                                            position: 'relative',
                                            textAlign: 'center',
                                            padding: '1%'
                                        },
                                        '& .MuiDataGrid-columnHeaders': {
                                            backgroundColor: '#7D9A47',
                                            color: 'white',
                                            fontWeight: 'bold',
                                            height: '20px'
                                        }
                                    }}
                                />
                            </Box>
                        </div>
                    </Typography>
                    <ThemeProvider theme={theme}>
                        <div className='col-12 col-md-12 d-flex justify-content-center'>
                            <Button variant="contained" color="secondary" style={{ width: '50%' }} onClick={() => { handleCloseModal() }}>Cerrar</Button>
                        </div>
                    </ThemeProvider>
                </Box>
            </Modal>
        </Fragment>
    )
} 
export default ModalHistorialCambiosComponent

